import { AiFixButton } from './AiFixButton';
import { ArchiveIssueButton } from './ArchiveIssueButton';
import { RestoreIssueButton } from './RestoreIssueButton';
import { SnoozeIssueButton } from './SnoozeIssueButton';
import { Space } from 'antd';
import { usePeriscopeActions } from '@hooks';
import { When } from 'react-if';

import { ActiveIndicator, PeriscopeSource } from '@ui/icons';
import { IssueBase, IssueVisibilityType } from '@sonar-software/sonar-issues';
import React, { useCallback } from 'react';

export interface IssueHeaderProps {
	hideActions?: boolean;
	issue: IssueBase;
	visibility: IssueVisibilityType;
}

export const IssueHeader: React.FC<IssueHeaderProps> = ({ hideActions, issue, visibility }) => {
	const { active, id, object, sonarObjectType, sourceUrl } = issue;

	const { openPeriscope } = usePeriscopeActions();

	const handleTitleClick = useCallback(
		(e: React.MouseEvent<HTMLDivElement>) => {
			const targetElementClasses = (e.target as HTMLElement).classList;

			if (
				targetElementClasses.contains('ant-card-head-title') ||
				targetElementClasses.contains('title-button') ||
				targetElementClasses.contains('issue-label')
			) {
				openPeriscope({
					id,
					name: object,
					openedFromIndex: -1,
					type: sonarObjectType
				});
			}
		},
		[ openPeriscope, id, object, sonarObjectType ]
	);

	const displayName = `${object} - ${name}`;
	const showRestore = visibility === IssueVisibilityType.Archived || visibility === IssueVisibilityType.Snoozed;

	return (
		<div
			className='title-button'
			onClick={ handleTitleClick }>
			<div className='ant-card-head-title'>
				<Space
					align='baseline'
					wrap>
					<span className='issue-label'>{ displayName }</span>
					<ActiveIndicator isActive={ active } />
					<PeriscopeSource
						id={ `issue-sf-link-${id}` }
						sonarObjectType={ sonarObjectType }
						url={ sourceUrl } />
				</Space>
				<When condition={ !hideActions }>
					<Space className='issue-actions'>
						{ !showRestore &&
							<>
								<SnoozeIssueButton sonarObjectId={ id } />
								<ArchiveIssueButton sonarObjectId={ id } />
							</> }
						{ showRestore && <RestoreIssueButton sonarObjectId={ id } /> }
						<AiFixButton sonarObjectId={ id } />
					</Space>
				</When>
			</div>
		</div>
	);
};
